<template>
    <div>
      <Header />
      <main>
        <section class="bg-dark position-relative overflow-hidden pt-xl-8" data-bs-theme="dark">
          <div class="position-absolute bottom-0 end-0 mb-n9">
            <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" class="opacity-2 blur-9" alt="Grad shape">
          </div>
          <div class="container position-relative pt-4 pt-sm-5">
            <span class="h2">👋</span>
            <h1 class="display-5 mt-3">{{ $t('contact.heading') }}</h1>
            <p class="mb-1">{{ $t('contact.subheading') }}</p>
            <p>{{ $t('contact.support_hours') }}: <span class="text-primary fw-bold">24/7</span></p>
          </div>
        </section>
  
        <section class="pt-0 mt-n6 mt-lg-n7 mt-xl-n8">
          <div class="container">
            <div class="row g-4 g-lg-5">
              <div class="col-md-6">
                <div class="card bg-secondary rounded-4 p-4 h-100">
                  <div class="card-body p-0">
                    <div class="icon-lg bg-primary text-white rounded-circle mb-3"><i class="bi bi-envelope"></i></div>
                    <h6>{{ $t('contact.mail_us') }}</h6>
                    <p class="mb-0">{{ $t('contact.mail_us_description') }}</p>
                  </div>
                  <div class="card-footer bg-transparent p-0 pt-3">
                    <a href="#" class="text-primary-grad">contact@visennia.com</a>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card bg-secondary rounded-4 p-4 h-100">
                  <div class="card-body p-0">
                    <div class="icon-lg bg-warning text-white rounded-circle mb-3"><i class="bi bi-headset"></i></div>
                    <h6>{{ $t('contact.support') }}</h6>
                    <p class="mb-0">{{ $t('contact.support_description') }}</p>
                  </div>
                  <div class="card-footer bg-transparent p-0 pt-3">
                    <a class="btn btn-sm btn-white-shadow icon-link icon-link-hover" href="#">{{ $t('contact.chat_now') }}<i class="bi bi-arrow-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        <section class="position-relative pt-0">
          <div class="container bg-secondary-grad rounded-4 p-4 p-md-6 p-xxl-8">
            <div class="inner-container-small">
              <h1 class="fw-bold mb-2 lh-base text-center"><i class="bi bi-emoji-smile me-2"></i>{{ $t('contact.form.your_name') }}</h1>
              <p class="text-center">{{ $t('contact.form.message') }}</p>
              <form class="row form-border-transparent g-3 mt-4">
                <div class="col-md-6">
                  <label class="form-label">{{ $t('contact.form.your_name') }}</label>
                  <input type="text" class="form-control">
                </div>
                <div class="col-md-6">
                  <label class="form-label">{{ $t('contact.form.email_address') }}</label>
                  <input type="email" class="form-control" id="floatingInput">
                </div>
                <div class="col-md-6">
                  <label class="form-label">{{ $t('contact.form.mobile_number') }}</label>
                  <input type="text" class="form-control">
                </div>
                <div class="col-md-6">
                  <label class="form-label">{{ $t('contact.form.subject') }}</label>
                  <input type="text" class="form-control">
                </div>
                <div class="col-12">
                  <label class="form-label">{{ $t('contact.form.message') }}</label>
                  <textarea class="form-control" id="floatingTextarea2" style="height: 100px"></textarea>
                </div>
                <div class="col-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input border" id="exampleCheck1">
                    <label class="form-check-label" for="exampleCheck1">{{ $t('contact.form.agree_checkbox') }}</label>
                  </div>
                </div>
                <div class="col-12 d-sm-flex align-items-center gap-3 mt-4">
                  <button class="btn btn-primary mb-2 mb-md-0">{{ $t('contact.form.send_message') }}</button>
                  <ul class="list-inline mb-0 ms-auto">
                    <li class="list-inline-item small heading-color">{{ $t('contact.form.connect_with') }}:</li>
                    <li class="list-inline-item"> <a href="https://www.instagram.com/visennia_/profilecard/?igsh=MXRobGJic2s3anZneA==" class="heading-color text-primary-hover"><i class="bi bi-instagram"></i></a> </li>
                  </ul>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  </template>
  

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {

    components: {
        Header,
        Footer
    }
};
</script>

<style scoped>
      
      
      </style>
